<template>
  <v-dialog v-model="show" persistent max-width="600px">
    <v-card>
      <v-card-title>
        <span style="font-size:16px;">更新资料</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-form ref="form">
            <v-text-field v-model="item.name" :rules="[rules.required]" label="姓名" required />
            <v-select v-model="item.age" :items="ageLookup" item-text="name" item-value="id" label="年龄" />
            <v-text-field v-model="item.email" :rules="[rules.email]" label="邮箱" />

            <v-text-field v-if="cShowYouPlusInfo" v-model="item.company" label="公司" />
            <v-text-field v-if="cShowYouPlusInfo" v-model="item.title" label="职位" />
            <v-select v-if="cShowYouPlusInfo" v-model="item.yearsOfWork" :items="yearLookup" item-text="name" item-value="id" label="工作年限" />

            <v-text-field v-if="cShowAnchorInfo" v-model="item.eduInstitution" label="学校" />
            <v-text-field v-if="cShowAnchorInfo" v-model="item.major" label="专业" />
            <v-select v-if="cShowAnchorInfo" v-model="item.grade" :items="gradeLookup" item-text="name" item-value="id" label="年级" />
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="#D04A02" flat @click="handleCancel">取消</v-btn>
        <v-btn color="#D04A02" flat @click="handleOk">确定</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { validRequired, validEmail } from '@/util/validation'
import { ProgrammeType } from '@/constants/type'

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    update: {
      type: Function,
      default: () => {}
    },
    programmeType: {
      type: Number,
      default: -1
    },
    info: {
      type: Object,
      default: () => { return {} }
    },
    ageLookup: {
      type: Array,
      default: () => []
    },
    yearLookup: {
      type: Array,
      default: () => []
    },
    gradeLookup: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      rules: {
        required: validRequired,
        email: validEmail
      },
      item: {
      }
    }
  },
  computed: {
    cShowAnchorInfo() {
      return this.programmeType === ProgrammeType.Anchor
    },
    cShowYouPlusInfo() {
      return this.programmeType === ProgrammeType.YouPlus
    }
  },
  watch: {
    info(n) {
      this.item = Object.assign({ }, this.item, n)
    }
  },
  created() {
    this.item = Object.assign({ }, this.item, this.info)
  },
  methods: {
    handleCancel() {
      this.$emit('update:show', false)
    },
    handleOk() {
      // hack, update avatar has it's own api
      Reflect.deleteProperty(this.item, 'profilePhotoUrl')

      if (!this.$refs.form.validate()) {
        return
      }
      const res = this.update(this.item)
      if (res instanceof Promise) {
        return res.then(() => {
          this.$emit('update:show', false)
        })
      } else {
        this.$emit('update:show', false)
      }
    }
  }
}
</script>

